import { SET_SOURCE } from './ExternalActions';

interface External {
  source?: 'DDAI';
}

type ExternalActionsKeys = keyof typeof actionsMap;

interface ExternalAction {
  type: ExternalActionsKeys;
  payload: Parameters<(typeof actionsMap)[ExternalActionsKeys]>[1];
}

const setSource = (state: External, payload: boolean) => ({
  ...state,
  source: payload,
});

const actionsMap = {
  [SET_SOURCE]: setSource,
};

const DEFAULT_STATE: External = {};

export const externalReducer = (
  state = DEFAULT_STATE,
  action: ExternalAction,
) => {
  if (actionsMap[action.type]) {
    return actionsMap[action.type](state, action.payload);
  }
  return state;
};
